import {inject, IReactComponent} from 'mobx-react';
import {SimpleModal} from '../../../../../../../components/simple-modal/component';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.multipartyDashboardStore.customerEndedTheMeetingModalController
});

export const CustomerEndedTheMeetingModal = inject(mapStoresToProps)(SimpleModal) as IReactComponent;
